import React from "react";
import { FormControl, Select, MenuItem, ListItemText } from "@mui/material";
import { useSelector } from "react-redux";
import { selectBUOptions } from "../../../../../features/dashboard/selectors";

// const OPTIONS = ["Global", "OBU", "IBBU", "CBU", "RDBU"];



const selectSx = {
  height: 36,
  width: 230,
  fontSize: "14px",
  borderRadius: "10px",
  "& .MuiSelect-select": { paddingY: 0.5, fontSize: "14px" },
  ".MuiOutlinedInput-notchedOutline": { border: "1px solid #e5e5ea" },
  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2" },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2" },
};

const BusinessUnitDropdown = ({ value, onChange, setTempSubAgentName }) => {

  const OPTIONS = useSelector(selectBUOptions);

  const handleChange = (e) => {
    onChange(e.target.value);
    setTempSubAgentName([]);
  };

  return (
    <FormControl fullWidth>
      <Select value={value} onChange={handleChange} sx={selectSx} displayEmpty
        renderValue={(selected) =>
          selected ? selected : (
            <span style={{ color: "#aaa", fontSize: "14px" }}>
              Select Business Unit
            </span>
          )
        }>
        {OPTIONS.map((opt) => (
          <MenuItem key={opt} value={opt}>
            <ListItemText primary={opt} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BusinessUnitDropdown;
